module.exports = "/_next/static/images/PrecisionSplicingNetworkActivation-ac3a48681a1e15bf2fee5421f0801feb.webp";